/** @format */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiService from "src/services/ApiService.js";
import Toast from "react-bootstrap/Toast";
import axios from "axios";

const createMutation = ({
  invalidateQueries = [],
  method,
  url,
  setQueriesData = () => [],
  transformRequest = (request) => request,
}) => {
  return ({
    onError,
    onSuccess,
    params = {},
    successMessage,
    toastErrorMessage,
  } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
      mutationFn: async (variables) => {
        variables = transformRequest(variables);
        const requestUrl = generateUrl({ url, params });
        const response = await apiService.fetchData({
          url: requestUrl,
          method,
          ...(method === "GET" ? { params: variables } : { data: variables }),
        });
        return response.data;
      },
      onSuccess: (data, variables) => {
        const _invalidateQueries = generateInvalidateQueries({
          invalidateQueries,
          body: variables,
          params,
        });
        _invalidateQueries.forEach((queryKey) => {
          queryClient.invalidateQueries(queryKey);
        });
        const queriesData = setQueriesData(variables, data, params);
        queriesData.forEach(([queryKey, updater, options]) => {
          queryClient.setQueryData(queryKey, updater, options);
        });
        if (onSuccess) onSuccess(data, variables, params);
        if (successMessage) {
          Toast.push({
            type: "success",
            description: successMessage,
          });
        }
      },
      onError: (props) => {
        if (axios.isAxiosError(props)) {
          const { response } = props;
          if (response) {
            const { data } = response;
            if (onError) onError(data);
            if (data.message && toastErrorMessage) {
              Toast.push({
                type: "danger",
                description: data.message,
              });
            }
          }
        }
      },
    });
  };
};

const generateUrl = ({ url, params }) => {
  if (!params) params = {};
  return typeof url === "function" ? url(params) : url;
};

const generateInvalidateQueries = ({ invalidateQueries, body, params }) => {
  if (typeof invalidateQueries === "function") {
    invalidateQueries = invalidateQueries(body, params);
  }
  if (Array.isArray(invalidateQueries[0])) {
    return invalidateQueries;
  } else {
    return [invalidateQueries];
  }
};

export default createMutation;
